import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "Dashboard": "Dashboard",
      "Patients": "Patients",
      "Settings": "Settings",
      "Help Manual": "Help Manual",
      "Logout": "Logout",
      "Welcome": "Welcome",
      "Management Overview": "Management Overview",
      "Search patient...": "Search patient by name or AMKA...",
      "Quick Actions": "Quick Actions",
      "New Patient": "New Patient",
      "System Backup": "System Backup",
      "Export All Data": "Export All Data",
      "Recent Activity": "Recent Activity",
      "No recent clinical changes": "No recent clinical changes",
      "View all patients": "View all patients",
      "Patient Growth Trend": "Patient Growth Trend",
      "Last 6 Months": "Last 6 Months",
      "New Patient Registrations": "New Patient Registrations",
      "Total Patients": "Total Patients",
      "Rectal Cancer": "Rectal Cancer",
      "Ca ΟΡΘΟΥ Cases": "Ca ΟΡΘΟΥ Cases",
      "Today's Activity": "Today's Activity",
      "Recent Files": "Recent Files",
      "Last 7 Days": "Last 7 Days",
      "Clinical Volume Trend": "Clinical Volume Trend",
      "Last 12 Months": "Last 12 Months",
      "Top Diagnoses": "Top Diagnoses",
      "Recent Rectal Cancer Visits": "Recent Rectal Cancer Visits",
      "New Rectal Cancer Cases": "New Rectal Cancer Cases",
      "No new cases in the last 3 months": "No new cases in the last 3 months",
      "Last 3 Months": "Last 3 Months",
      "New": "New",
      "Medical History": "Medical History",
      "Visits": "Visits",
      "Operations": "Operations",
      "Medications": "Medications",
      "Patient Files": "Patient Files",
      "Gallery": "Gallery",
      "Documents": "Documents",
      "this month": "this month",
      "Active Patient": "Active Patient",
      "Close": "Close",
      "ID": "ID",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Age": "Age",
      "Gender": "Gender",
      "Diagnosis": "Diagnosis",
      "Phone": "Phone",
      "Email": "Email",
      "AMKA": "AMKA",
      "AM": "AM",
      "Address": "Address",
      "Notes": "Notes",
      "Allergies": "Allergies",
      "Death": "Death",
      "Last Visit": "Last Visit",
      "Card Date": "Card Date",
      "Updated": "Updated",
      "Actions": "Actions",
      "Search patients by name...": "Search by name, diagnosis, AMKA, phone...",
      "Form View": "Form View",
      "Table": "Table",
      "Cards": "Cards",
      "Table View": "Table View",
      "Cards View": "Cards View",
      "Patient Records": "Patient Records",
      "Select a patient": "Select a patient from the list to view their details.",
      "EMR Portal": "EMR Portal",
      "Switch to Greek": "Switch to Greek",
      "Switch to English": "Switch to English",
      "Notifications": "Notifications",
      "PATIENT CLINICAL SUMMARY": "PATIENT CLINICAL SUMMARY",
      "MySurgeon EMR - Comprehensive Health Record": "MySurgeon EMR - Comprehensive Health Record",
      "Ref:": "Ref:",
      "Date:": "Date:",
      "Age / Gender": "Age / Gender",
      "AMKA / SSN": "AMKA / SSN",
      "Chief Diagnosis": "Chief Diagnosis",
      "Height / Weight": "Height / Weight",
      "Previous Surgeries": "Previous Surgeries",
      "Cardiovascular": "Cardiovascular",
      "Respiratory": "Respiratory",
      "Endocrine": "Endocrine",
      "Neurological": "Neurological",
      "Personal Habits / Lifestyle": "Personal Habits / Lifestyle",
      "Clinical Notes": "Clinical Notes",
      "Medication List": "Medication List",
      "Drug Name": "Drug Name",
      "Dosage / Frequency": "Dosage / Frequency",
      "Timeline": "Timeline",
      "Clinical Visits History": "Clinical Visits History",
      "Clinical Encounter": "Clinical Encounter",
      "Findings/Diagnosis:": "Findings/Diagnosis:",
      "Treatment Plan:": "Treatment Plan:",
      "Surgical Operations": "Surgical Operations",
      "Procedure Type": "Procedure Type",
      "Hospital / Surgeon": "Hospital / Surgeon",
      "Outcome / Findings": "Outcome / Findings",
      "Diagnostic Files & Documents": "Diagnostic Files & Documents",
      "Date Added": "Date Added",
      "Confidential Clinical Documentation": "Confidential Clinical Documentation",
      "MySurgeon EMR Intelligence": "MySurgeon EMR Intelligence",
      "Page": "Page",
      "Unknown Patient": "Unknown Patient",
      "to": "to",
      "Ongoing": "Ongoing",
      "Active": "Active",
      "active": "active",
      "Completed": "Completed",
      "Discontinued": "Discontinued",
      "Clinical Report": "Clinical Report",
      "Follow-up": "Follow-up",
      "Patient File Preview": "Patient File Preview",
      "Exit full screen": "Exit full screen",
      "View full screen": "View full screen",
      "Select File": "Select File",
      "None": "None",
      "Select a file to preview.": "Select a file to preview.",
      "File Preview": "File Preview",
      "Failed to load preview": "Failed to load preview",
      "Full Clinical Report Preview": "Full Clinical Report Preview",
      "Print Report": "Print Report",
      "Clinical Report Preview": "Clinical Report Preview",
      "Detailed History Records": "Detailed History Records",
      "Clinical PDF Document": "Clinical PDF Document",
      "Open Full PDF": "Open Full PDF",
      "Back to Patients": "Back to Patients",
      "Administrator": "Administrator",
      "User": "User",
      "Viewer": "Viewer",
      "Logged in as": "Logged in as",
      "First patient": "First patient",
      "Previous patient": "Previous patient",
      "Next patient": "Next patient",
      "Last patient": "Last patient",
      "Refresh": "Refresh",
      "Edit": "Edit",
      "Print": "Print",
      "Delete": "Delete",
      "Diagnosis:": "Diagnosis:",
      "Age:": "Age:",
      "Card Date:": "Card Date:",
      "Folder:": "Folder:",
      "Not available": "Not available",
      "Open Folder": "Open Folder",
      "Open gallery": "Open gallery",
      "Copy": "Copy",
      "Save": "Save",
      "Cancel": "Cancel",
      "Preparing...": "Preparing...",
      "1. Medical History": "1. Medical History",
      "2. Visits": "2. Visits",
      "3. Operations": "3. Operations",
      "4. Medications": "4. Medications",
      "5. Patient Files": "5. Patient Files",
      "6. Gallery": "6. Gallery",
      "Updated At": "Updated At",
      "General": "General",
      "Server Connection": "Server Connection",
      "Folders": "Folders",
      "Migration": "Migration",
      "Users": "Users",
      "Database": "Database",
      "System Migration": "System Migration",
      "Preferences": "Preferences",
      "Dark Mode": "Dark Mode",
      "Patient Change Notifications": "Patient Change Notifications",
      "On": "On",
      "Off": "Off",
      "Manage your preferences and profile.": "Manage your preferences and profile.",
      "Switch between light and dark interface": "Switch between light and dark interface",
      "Receive notifications when patient records are modified": "Receive notifications when patient records are modified",
      "Add Patient": "Add Patient",
      "Edit Patient": "Edit Patient",
      "Personal Information": "Personal Information",
      "Contact Details": "Contact Details",
      "Clinical Profile": "Clinical Profile",
      "Date of Birth": "Date of Birth",
      "Male": "Male",
      "Female": "Female",
      "Other": "Other",
      "Patient Query": "Patient Query",
      "Query": "Query",
      "Filter Patients": "Filter Patients",
      "Age From": "Age From",
      "Age To": "Age To",
      "Date From": "Date From",
      "Date To": "Date To",
      "Export": "Export",
      "Export to Excel": "Export to Excel",
      "Print Query Results": "Print Results",
      "Results Found": "Results Found",
      "No patients found matching your criteria.": "No patients found matching your criteria.",
      "Search by name, AMKA, diagnosis...": "Search by name, AMKA, diagnosis...",
      "Total Count": "Total Count",
      "Clear Filters": "Clear Filters",
      "Last Visit From": "Last Visit From",
      "Last Visit To": "Last Visit To",
      "AMKA must be exactly 11 digits": "AMKA must be exactly 11 digits",
      "Session & Security": "Session & Security",
      "Idle Session Timeout": "Idle Session Timeout",
      "Automatically sign out after a period of inactivity": "Automatically sign out after a period of inactivity",
      "Sign Out on Tab Close": "Sign Out on Tab Close",
      "Always active for clinical data security": "Always active for clinical data security",
      "Minutes": "Minutes",
      "Help Manual Desc": "A comprehensive guide to managing your clinical workflows, patient records, and system settings efficiently.",
      "Quick Navigation": "QUICK NAVIGATION",
      "Need extra support": "Need extra clinical support? Contact your system administrator.",
      "Overview": "Overview",
      "Clinical Files": "Clinical Files",
      "Sync Hub": "Sync Hub",
      "Surgical Operations": "Surgical Operations",
      "Surgical Operations Desc": "Learn how to use the dashboard, monitor clinical alerts, and access quick actions.",
      "Real-Time Clinical Alerts": "Real-Time Clinical Alerts",
      "Real-Time Clinical Alerts Desc": "The bell icon in the top-right corner notifies all medical staff when patient records are created, updated, or deleted. These alerts work across all connected workstations instantly.",
      "Patient Management": "Patient Management",
      "Patient Management Desc": "Comprehensive guide on recording patient details, medical histories, prescribing medications, and logging visits.",
      "Recording Medical History": "Recording Medical History",
      "Recording Medical History Desc": "Within the Patient Detail page, use the 'Medical History' tab to record patient weight, height, and chronic conditions. All fields are automatically timestamped for medical verification.",
      "Surgical Medications": "Clinical Medications",
      "Surgical Medications Desc": "The 'Medications' tab allows for rich clinical record-keeping. You can track dosages, frequencies, and start/stop dates to ensure comprehensive patient safety.",
      "Tracking Clinical Visits": "Tracking Clinical Visits",
      "Tracking Clinical Visits Desc": "Use the 'Visits' tab to document every patient encounter, including chief complaints, findings, and treatment plans. This maintains a chronologically ordered medical timeline.",
      "Digital Surgical Files": "Digital Clinical Files",
      "Digital Surgical Files Desc": "Managing high-fidelity clinical photos, lab results, and PDF documents.",
      "Uploading Surgical Photos": "Uploading Clinical Photos",
      "Uploading Surgical Photos Desc": "The 'Patient Files' tab supports high-resolution clinical JPEG and PNG images. Documents are stored in a dedicated high-fidelity folder on the central server.",
      "Scanning & Thumbnails": "Scanning & Thumbnails",
      "Scanning & Thumbnails Desc": "The application automatically generates high-fidelity thumbnails for all clinical documents and photos, allowing for fast visual scanning of patient records in the Gallery view.",
      "Generating Clinical Reports": "Generating Clinical Reports",
      "Generating Clinical Reports Desc": "MyEMR can automatically generate comprehensive PDF reports summarizing a patient's entire medical profile, including history, visits, medications, and attached diagnostic files for printing or sharing.",
      "Clinical Synchronization": "Clinical Synchronization",
      "Clinical Synchronization Desc": "Connecting and synchronizing multiple workstations to the primary server securely.",
      "Connecting a New Workstation": "Connecting a New Workstation",
      "Connecting a New Workstation Desc": "To connect a new client, input the primary Server IP into the settings page. Data is synced in real-time, ensuring all workstations have the latest patient records.",
      "System Maintenance": "System Maintenance",
      "System Maintenance Desc": "Performing automated backups, system migrations, and database management.",
      "Proxmox Migration": "System Migration",
      "Proxmox Migration Desc": "To move the system, use the Settings > System Migration tab. This creates a single ZIP bundle containing all database records and clinical files for effortless restoration.",
      "Automated Backups": "Automated Backups",
      "Automated Backups Desc": "The system features one-click backup functionality. Navigate to Settings to download a secure copy of your database, guaranteeing your data is safe against hardware failures.",
      "Query & Export": "Query & Export",
      "Query & Export Desc": "Advanced patient filtering and data exporting.",
      "Advanced Filtering": "Advanced Filtering",
      "Advanced Filtering Desc": "Use the Query page to filter patients based on specific criteria such as age range, last visit date, and diagnosis to identify target demographics or follow-ups.",
      "Excel Export": "Excel Export",
      "Excel Export Desc": "Easily export your query results to a beautifully formatted Excel sheet for external auditing, reporting, or further medical research analysis.",
      "Profile": "Profile",
      "Account Description": "Account Description",
      "Full access — read, write, delete, manage users": "Full access — read, write, delete, manage users",
      "Can add & edit patients, cannot delete": "Can add & edit patients, cannot delete",
      "Read-only access to all patient data": "Read-only access to all patient data",
      "Patient Medical Record": "Patient Medical Record",
      "Cards per page": "Cards per page",
      "Delete Patient": "Delete Patient",
      "Are you sure you want to delete patient": "Are you sure you want to delete patient",
      "This action cannot be undone.": "This action cannot be undone.",
      "records": "records",
      "patients": "patients",
      "Protocol": "Protocol",
      "Select PC": "Select PC",
      "Add new PC": "Add new PC",
      "Delete Folder Configuration": "Delete Folder Configuration",
      "This will permanently delete all patient data": "This will permanently delete all patient data",
      "This cannot be undone": "This cannot be undone",
      "To confirm, please type DELETE ALL PATIENTS below": "To confirm, please type DELETE ALL PATIENTS below",
      "To proceed, please type RESTORE SYSTEM below": "To proceed, please type RESTORE SYSTEM below",
      "View patients & records": "View patients & records",
      "Add new patients": "Add new patients",
      "Edit patient data": "Edit patient data",
      "Delete patients": "Delete patients",
      "Add visits / medications / operations": "Add visits / medications / operations",
      "Delete visits / medications / operations": "Delete visits / medications / operations",
      "Access Settings & User Management": "Access Settings & User Management",
      "Create / delete users": "Create / delete users",
      "Final Confirmation": "Final Confirmation",
      "Only administrators can delete patients": "Only administrators can delete patients",
      "Server Connection Settings": "Server Connection Settings",
      "Configure the primary surgical hub location. These settings are stored locally on this device and are used to reach the clinical database server on your network.": "Configure the primary surgical hub location. These settings are stored locally on this device and are used to reach the clinical database server on your network.",
      "Server IP or Hostname": "Server IP or Hostname",
      "Port": "Port",
      "Test Connection": "Test Connection",
      "Reset to Default": "Reset to Default",
      "Save & Apply": "Save & Apply",
      "Patient Data Folders": "Patient Data Folders",
      "Configure the base directories for different PCs where patient files are stored.": "Configure the base directories for different PCs where patient files are stored.",
      "Create New User": "Create New User",
      "Create User": "Create User",
      "Edit User": "Edit User",
      "Lock Account": "Lock Account",
      "Unlock Account": "Unlock Account",
      "Delete user permanently": "Delete user permanently",
      "HTTP (Standard)": "HTTP (Standard)",
      "HTTPS (Secure)": "HTTPS (Secure)",
      "Connection Username": "Connection Username",
      "Connection Password": "Connection Password",
      "CONNECTION CREDENTIALS (OPTIONAL)": "CONNECTION CREDENTIALS (OPTIONAL)",
      "The IP address of the machine running the Hub": "The IP address of the machine running the Hub",
      "Only if required by proxy/gateway": "Only if required by proxy/gateway",
      "Only if required": "Only if required",
      "Clinical Environment": "Clinical Environment",
      "Standalone App (macOS)": "Standalone App (macOS)",
      "Current Active Endpoint": "Current Active Endpoint",
      "Server path": "Server path",
      "Local path": "Local path",
      "Select Server PC": "Select Server PC",
      "Select Local PC": "Select Local PC",
      "Batch Diagnosis Lookup": "Batch Diagnosis Lookup",
      "Batch Diagnosis Lookup & Export": "Batch Diagnosis Lookup & Export",
      "Batch Diagnosis Lookup (Import XLSX/CSV)": "Batch Diagnosis Lookup (Import XLSX/CSV)",
      "Upload an Excel or CSV list of names to automatically find their clinical diagnoses and export.": "Upload an Excel or CSV list of names to automatically find their clinical diagnoses and export.",
      "1. Import & Map Columns": "1. Import & Map Columns",
      "2. Match Diagnoses & Export": "2. Match Diagnoses & Export",
      "Drag & drop your patient list here": "Drag & drop your patient list here",
      "Supports Excel (.xlsx, .xls) and CSV (.csv) files": "Supports Excel (.xlsx, .xls) and CSV (.csv) files",
      "Browse File": "Browse File",
      "Change File": "Change File",
      "Remove File": "Remove File",
      "Column Mapping & Configuration": "Column Mapping & Configuration",
      "Select which columns contain patient names to match against clinical records.": "Select which columns contain patient names to match against clinical records.",
      "Single Full Name Column": "Single Full Name Column",
      "Separate Last & First Names": "Separate Last & First Names",
      "Patient Full Name Column": "Patient Full Name Column",
      "Last Name (Επώνυμο)": "Last Name (Επώνυμο)",
      "First Name (Όνομα)": "First Name (Όνομα)",
      "AMKA (Optional)": "AMKA (Optional)",
      "Phone (Optional)": "Phone (Optional)",
      "DOB (Optional)": "DOB (Optional)",
      "None / Not in file": "None / Not in file",
      "Previewing first {{count}} rows of {{total}} loaded records": "Previewing first {{count}} rows of {{total}} loaded records",
      "Records": "Records",
      "Searching & Matching Diagnoses...": "Searching & Matching Diagnoses...",
      "Find Diagnoses for {{count}} Patients": "Find Diagnoses for {{count}} Patients",
      "New File Lookup": "New File Lookup",
      "Adjust Mapping": "Adjust Mapping",
      "Exact Match": "Exact Match",
      "Multiple Matches": "Multiple Matches",
      "Multiple Candidates": "Multiple Candidates",
      "Approximate": "Approximate",
      "Not Found": "Not Found",
      "Found": "Found",
      "Total Records": "Total Records",
      "Exact Matches": "Exact Matches",
      "Imported Search Name": "Imported Search Name",
      "Matched Patient": "Matched Patient",
      "Primary Diagnosis": "Primary Diagnosis",
      "Latest Visit Diagnosis": "Latest Visit Diagnosis",
      "No diagnosis recorded": "No diagnosis recorded",
      "Change Match ({{count}} found)": "Change Match ({{count}} found)",
      "Select Matching Patient": "Select Matching Patient",
      "Multiple patient records match \"{{name}}\". Choose the correct patient below:": "Multiple patient records match \"{{name}}\". Choose the correct patient below:",
      "Export to Excel (.xlsx)": "Export to Excel (.xlsx)",
      "Export to CSV": "Export to CSV",
      "Quick Export: Excel (.xlsx)": "Quick Export: Excel (.xlsx)",
      "Quick Export: CSV (.csv)": "Quick Export: CSV (.csv)",
      "Customized Export Options...": "Customized Export Options...",
      "Export Diagnosis Lookup Results": "Export Diagnosis Lookup Results",
      "Choose how you would like the exported file to be structured:": "Choose how you would like the exported file to be structured:",
      "Preserve Original Columns + Append Diagnoses (Recommended)": "Preserve Original Columns + Append Diagnoses (Recommended)",
      "Keeps all columns from your imported Excel/CSV file and appends EMR_Primary_Diagnosis, EMR_Matched_Name, EMR_AMKA, and EMR_Match_Status.": "Keeps all columns from your imported Excel/CSV file and appends EMR_Primary_Diagnosis, EMR_Matched_Name, EMR_AMKA, and EMR_Match_Status.",
      "Standardized Clinical Summary Report": "Standardized Clinical Summary Report",
      "Generates a clean report containing Row #, Search Name, Matched Patient, Diagnosis, Latest Visit Diagnosis, AMKA, Age, and Phone.": "Generates a clean report containing Row #, Search Name, Matched Patient, Diagnosis, Latest Visit Diagnosis, AMKA, Age, and Phone.",
      "Clinical Query & Filters": "Clinical Query & Filters",
      "Patient Query & Lookup": "Patient Query & Lookup",
      "About System": "About System",
      "Application Version": "Application Version",
      "MySurgeon Clinical EMR Suite": "MySurgeon Clinical EMR Suite",
      "Clinical Suite": "Clinical Suite"
    }
  },
  el: {
    translation: {
      "Dashboard": "Αρχική",
      "Patients": "Ασθενείς",
      "Settings": "Ρυθμίσεις",
      "Help Manual": "Εγχειρίδιο Χρήσης",
      "Logout": "Αποσύνδεση",
      "Welcome": "Καλώς ήρθατε",
      "Management Overview": "Επισκόπηση Διαχείρισης",
      "Search patient...": "Αναζήτηση ασθενή με όνομα ή ΑΜΚΑ...",
      "Quick Actions": "Γρήγορες Ενέργειες",
      "New Patient": "Νέος Ασθενής",
      "System Backup": "Αντίγραφο Ασφαλείας",
      "Export All Data": "Εξαγωγή Όλων",
      "Recent Activity": "Πρόσφατη Δραστηριότητα",
      "No recent clinical changes": "Δεν υπάρχουν πρόσφατες αλλαγές",
      "View all patients": "Προβολή όλων των ασθενών",
      "Patient Growth Trend": "Τάση Ανάπτυξης Ασθενών",
      "Last 6 Months": "Τελευταίοι 6 Μήνες",
      "New Patient Registrations": "Νέες Εγγραφές Ασθενών",
      "Total Patients": "Σύνολο Ασθενών",
      "Rectal Cancer": "Καρκίνος Ορθού",
      "Ca ΟΡΘΟΥ Cases": "Περιστατικά Ca ΟΡΘΟΥ",
      "Today's Activity": "Σημερινή Δραστηριότητα",
      "Recent Files": "Πρόσφατα Αρχεία",
      "Last 7 Days": "Τελευταίες 7 Ημέρες",
      "Clinical Volume Trend": "Τάση Κλινικού Φόρτου",
      "Last 12 Months": "Τελευταίοι 12 Μήνες",
      "Top Diagnoses": "Κύριες Διαγνώσεις",
      "Recent Rectal Cancer Visits": "Πρόσφατες Επισκέψεις Ca ΟΡΘΟΥ",
      "New Rectal Cancer Cases": "Νέα Περιστατικά Ca ΟΡΘΟΥ",
      "No new cases in the last 3 months": "Δεν υπάρχουν νέα περιστατικά το τελευταίο 3μηνο",
      "Last 3 Months": "Τελευταίο 3μηνο",
      "New": "Νέο",
      "Medical History": "Ιστορικό",
      "Visits": "Επισκέψεις",
      "Operations": "Επεμβάσεις",
      "Medications": "Φάρμακα",
      "Patient Files": "Αρχεία Ασθενή",
      "Gallery": "Γκαλερί",
      "Documents": "Έγγραφα",
      "this month": "αυτόν το μήνα",
      "Active Patient": "Ενεργός Ασθενής",
      "Close": "Κλείσιμο",
      "ID": "ID",
      "First Name": "Όνομα",
      "Last Name": "Επίθετο",
      "Age": "Ηλικία",
      "Gender": "Φύλο",
      "Diagnosis": "Διάγνωση",
      "Phone": "Τηλέφωνο",
      "Email": "Email",
      "AMKA": "ΑΜΚΑ",
      "AM": "ΑΜ",
      "Address": "Διεύθυνση",
      "Notes": "Σημειώσεις",
      "Allergies": "Αλλεργίες",
      "Death": "Θάνατος",
      "Last Visit": "Τελ. Επίσκεψη",
      "Card Date": "Ημ/νία Κάρτας",
      "Updated": "Ενημερώθηκε",
      "Actions": "Ενέργειες",
      "Search patients by name...": "Αναζήτηση με όνομα, διάγνωση, ΑΜΚΑ, τηλέφωνο...",
      "Form View": "Προβολή Φόρμας",
      "Table": "Πίνακας",
      "Cards": "Κάρτες",
      "Table View": "Προβολή Πίνακα",
      "Cards View": "Προβολή Καρτών",
      "Patient Records": "Αρχεία Ασθενών",
      "Select a patient": "Επιλέξτε έναν ασθενή από τη λίστα για να δείτε λεπτομέρειες.",
      "EMR Portal": "EMR Portal",
      "Switch to Greek": "Αλλαγή στα Ελληνικά",
      "Switch to English": "Switch to English",
      "Notifications": "Ειδοποιήσεις",
      "PATIENT CLINICAL SUMMARY": "ΚΛΙΝΙΚΗ ΣΥΝΟΨΗ ΑΣΘΕΝΟΥΣ",
      "MySurgeon EMR - Comprehensive Health Record": "MySurgeon EMR - Πλήρης Ιατρικός Φάκελος",
      "Ref:": "Κωδ:",
      "Date:": "Ημερομηνία:",
      "Age / Gender": "Ηλικία / Φύλο",
      "AMKA / SSN": "ΑΜΚΑ",
      "Chief Diagnosis": "Κύρια Διάγνωση",
      "Height / Weight": "Ύψος / Βάρος",
      "Previous Surgeries": "Προηγούμενες Επεμβάσεις",
      "Cardiovascular": "Καρδιαγγειακό",
      "Respiratory": "Αναπνευστικό",
      "Endocrine": "Ενδοκρινικό",
      "Neurological": "Νευρολογικό",
      "Personal Habits / Lifestyle": "Συνήθειες / Τρόπος Ζωής",
      "Clinical Notes": "Κλινικές Σημειώσεις",
      "Medication List": "Λίστα Φαρμακευτικής Αγωγής",
      "Drug Name": "Φάρμακο",
      "Dosage / Frequency": "Δοσολογία / Συχνότητα",
      "Timeline": "Διάρκεια",
      "Clinical Visits History": "Ιστορικό Κλινικών Επισκέψεων",
      "Clinical Encounter": "Κλινική Επίσκεψη",
      "Findings/Diagnosis:": "Ευρήματα/Διάγνωση:",
      "Treatment Plan:": "Θεραπευτικό Πλάνο:",
      "Surgical Operations": "Χειρουργικές Επεμβάσεις",
      "Procedure Type": "Είδος Επέμβασης",
      "Hospital / Surgeon": "Νοσοκομείο / Χειρουργός",
      "Outcome / Findings": "Έκβαση / Ευρήματα",
      "Diagnostic Files & Documents": "Διαγνωστικά Αρχεία & Έγγραφα",
      "Date Added": "Ημ/νία Προσθήκης",
      "Confidential Clinical Documentation": "Εμπιστευτικό Κλινικό Έγγραφο",
      "MySurgeon EMR Intelligence": "MySurgeon EMR Intelligence",
      "Page": "Σελίδα",
      "Unknown Patient": "Άγνωστος Ασθενής",
      "to": "έως",
      "Ongoing": "Σε εξέλιξη",
      "Active": "Ενεργό",
      "active": "ενεργό",
      "Completed": "Ολοκληρώθηκε",
      "Discontinued": "Διακόπηκε",
      "Clinical Report": "Κλινική Αναφορά",
      "Follow-up": "Επανεξέταση",
      "Patient File Preview": "Προεπισκόπηση Αρχείου Ασθενή",
      "Exit full screen": "Έξοδος από πλήρη οθόνη",
      "View full screen": "Προβολή σε πλήρη οθόνη",
      "Select File": "Επιλογή Αρχείου",
      "None": "Κανένα",
      "Select a file to preview.": "Επιλέξτε ένα αρχείο για προεπισκόπηση.",
      "File Preview": "Προεπισκόπηση Αρχείου",
      "Failed to load preview": "Αποτυχία φόρτωσης προεπισκόπησης",
      "Full Clinical Report Preview": "Προεπισκόπηση Πλήρους Κλινικής Αναφοράς",
      "Print Report": "Εκτύπωση Αναφοράς",
      "Clinical Report Preview": "Προεπισκόπηση Κλινικής Αναφοράς",
      "Detailed History Records": "Λεπτομερή Στοιχεία Ιστορικού",
      "Clinical PDF Document": "Κλινικό Έγγραφο PDF",
      "Open Full PDF": "Άνοιγμα PDF",
      "Back to Patients": "Επιστροφή στους Ασθενείς",
      "Administrator": "Διαχειριστής",
      "User": "Χρήστης",
      "Viewer": "Αναγνώστης",
      "Logged in as": "Συνδεδεμένος ως",
      "First patient": "Πρώτος ασθενής",
      "Previous patient": "Προηγούμενος ασθενής",
      "Next patient": "Επόμενος ασθενής",
      "Last patient": "Τελευταίος ασθενής",
      "Refresh": "Ανανέωση",
      "Edit": "Επεξεργασία",
      "Print": "Εκτύπωση",
      "Delete": "Διαγραφή",
      "Diagnosis:": "Διάγνωση:",
      "Age:": "Ηλικία:",
      "Card Date:": "Ημ/νία Κάρτας:",
      "Folder:": "Φάκελος:",
      "Not available": "Μη διαθέσιμο",
      "Open Folder": "Άνοιγμα Φακέλου",
      "Open gallery": "Άνοιγμα γκαλερί",
      "Copy": "Αντιγραφή",
      "Save": "Αποθήκευση",
      "Cancel": "Ακύρωση",
      "Preparing...": "Προετοιμασία...",
      "1. Medical History": "1. Ιστορικό",
      "2. Visits": "2. Επισκέψεις",
      "3. Operations": "3. Επεμβάσεις",
      "4. Medications": "4. Φάρμακα",
      "5. Patient Files": "5. Αρχεία Ασθενή",
      "6. Gallery": "6. Γκαλερί",
      "Updated At": "Ενημερώθηκε στίς",
      "General": "Γενικά",
      "Server Connection": "Σύνδεση Διακομιστή",
      "Folders": "Φάκελοι",
      "Migration": "Μεταφορά Δεδομένων",
      "Users": "Χρήστες",
      "Database": "Βάση Δεδομένων",
      "System Migration": "Μεταφορά Συστήματος",
      "Preferences": "Προτιμήσεις",
      "Dark Mode": "Σκοτεινή Λειτουργία",
      "Patient Change Notifications": "Ειδοποιήσεις Αλλαγής Ασθενούς",
      "On": "Ναι",
      "Off": "Όχι",
      "Manage your preferences and profile.": "Διαχειριστείτε τις προτιμήσεις και το προφίλ σας.",
      "Switch between light and dark interface": "Εναλλαγή μεταξύ φωτεινού και σκοτεινού περιβάλλοντος",
      "Receive notifications when patient records are modified": "Λήψη ειδοποιήσεων όταν τροποποιούνται τα αρχεία ασθενών",
      "Add Patient": "Προσθήκη Ασθενή",
      "Edit Patient": "Επεξεργασία Ασθενή",
      "Personal Information": "Προσωπικά Στοιχεία",
      "Contact Details": "Στοιχεία Επικοινωνίας",
      "Clinical Profile": "Κλινικό Προφίλ",
      "Date of Birth": "Ημερομηνία Γέννησης",
      "Male": "Άνδρας",
      "Female": "Γυναίκα",
      "Other": "Άλλο",
      "Patient Query": "Αναζήτηση Ασθενών",
      "Query": "Αναζήτηση",
      "Filter Patients": "Φίλτρα Ασθενών",
      "Age From": "Ηλικία Από",
      "Age To": "Ηλικία Έως",
      "Date From": "Ημ/νία Από",
      "Date To": "Ημ/νία Έως",
      "Export": "Εξαγωγή",
      "Export to Excel": "Εξαγωγή σε Excel",
      "Print Query Results": "Εκτύπωση Αποτελεσμάτων",
      "Results Found": "Αποτελέσματα",
      "No patients found matching your criteria.": "Δεν βρέθηκαν ασθενείς με αυτά τα κριτήρια.",
      "Search by name, AMKA, diagnosis...": "Αναζήτηση με όνομα, ΑΜΚΑ, διάγνωση...",
      "Total Count": "Σύνολο",
      "Clear Filters": "Καθαρισμός",
      "Last Visit From": "Τελ. Επίσκεψη Από",
      "Last Visit To": "Τελ. Επίσκεψη Έως",
      "AMKA must be exactly 11 digits": "Ο ΑΜΚΑ πρέπει να έχει ακριβώς 11 ψηφία",
      "Session & Security": "Περίοδος Σύνδεσης & Ασφάλεια",
      "Idle Session Timeout": "Χρονικό Όριο Αδράνειας",
      "Automatically sign out after a period of inactivity": "Αυτόματη αποσύνδεση μετά από μια περίοδο αδράνειας",
      "Sign Out on Tab Close": "Αποσύνδεση κατά το Κλείσιμο της Καρτέλας",
      "Always active for clinical data security": "Πάντα ενεργό για την ασφάλεια των κλινικών δεδομένων",
      "Minutes": "Λεπτά",
      "Help Manual Desc": "Ένας πλήρης οδηγός για την αποτελεσματική διαχείριση των κλινικών ροών εργασίας, των αρχείων ασθενών και των ρυθμίσεων του συστήματος.",
      "Quick Navigation": "ΓΡΗΓΟΡΗ ΠΛΟΗΓΗΣΗ",
      "Need extra support": "Χρειάζεστε επιπλέον κλινική υποστήριξη; Επικοινωνήστε με τον διαχειριστή του συστήματος.",
      "Overview": "Επισκόπηση",
      "Clinical Files": "Κλινικά Αρχεία",
      "Sync Hub": "Συγχρονισμός",
      "Surgical Operations": "Κλινικές Λειτουργίες",
      "Surgical Operations Desc": "Μάθετε πώς να χρησιμοποιείτε την αρχική σελίδα, να παρακολουθείτε κλινικές ειδοποιήσεις και να έχετε πρόσβαση σε γρήγορες ενέργειες.",
      "Real-Time Clinical Alerts": "Κλινικές Ειδοποιήσεις σε Πραγματικό Χρόνο",
      "Real-Time Clinical Alerts Desc": "Το εικονίδιο του κουδουνιού στο πάνω δεξιά μέρος ειδοποιεί το ιατρικό προσωπικό όταν δημιουργούνται, ενημερώνονται ή διαγράφονται αρχεία ασθενών. Αυτές οι ειδοποιήσεις λειτουργούν άμεσα σε όλους τους συνδεδεμένους σταθμούς εργασίας.",
      "Patient Management": "Διαχείριση Ασθενών",
      "Patient Management Desc": "Πλήρης οδηγός για την καταγραφή στοιχείων ασθενών, ιατρικού ιστορικού, συνταγογράφησης φαρμάκων και καταγραφής επισκέψεων.",
      "Recording Medical History": "Καταγραφή Ιατρικού Ιστορικού",
      "Recording Medical History Desc": "Στη σελίδα Λεπτομερειών Ασθενούς, χρησιμοποιήστε την καρτέλα 'Ιστορικό' για να καταγράψετε βάρος, ύψος και χρόνιες παθήσεις. Όλα τα πεδία χρονοσημαίνονται αυτόματα για ιατρική επιβεβαίωση.",
      "Surgical Medications": "Φαρμακευτική Αγωγή",
      "Surgical Medications Desc": "Η καρτέλα 'Φάρμακα' επιτρέπει την πλήρη κλινική καταγραφή. Μπορείτε να παρακολουθείτε δοσολογίες, συχνότητες και ημερομηνίες έναρξης/λήξης για να διασφαλίσετε την ασφάλεια του ασθενούς.",
      "Tracking Clinical Visits": "Παρακολούθηση Κλινικών Επισκέψεων",
      "Tracking Clinical Visits Desc": "Χρησιμοποιήστε την καρτέλα 'Επισκέψεις' για να τεκμηριώσετε κάθε συνάντηση με τον ασθενή, συμπεριλαμβανομένων των κύριων συμπτωμάτων, των ευρημάτων και των θεραπευτικών πλάνων.",
      "Digital Surgical Files": "Ψηφιακά Κλινικά Αρχεία",
      "Digital Surgical Files Desc": "Διαχείριση κλινικών φωτογραφιών υψηλής πιστότητας, εργαστηριακών αποτελεσμάτων και εγγράφων PDF.",
      "Uploading Surgical Photos": "Μεταφόρτωση Κλινικών Φωτογραφιών",
      "Uploading Surgical Photos Desc": "Η καρτέλα 'Αρχεία Ασθενή' υποστηρίζει εικόνες JPEG και PNG υψηλής ανάλυσης. Τα έγγραφα αποθηκεύονται σε ειδικό φάκελο υψηλής πιστότητας στον κεντρικό διακομιστή.",
      "Scanning & Thumbnails": "Σάρωση & Μικρογραφίες",
      "Scanning & Thumbnails Desc": "Η εφαρμογή δημιουργεί αυτόματα μικρογραφίες υψηλής πιστότητας για όλα τα κλινικά έγγραφα και τις φωτογραφίες, επιτρέποντας τη γρήγορη οπτική σάρωση στη Γκαλερί.",
      "Generating Clinical Reports": "Δημιουργία Κλινικών Αναφορών",
      "Generating Clinical Reports Desc": "Το MyEMR μπορεί να δημιουργήσει αυτόματα πλήρεις αναφορές PDF που συνοψίζουν ολόκληρο το ιατρικό προφίλ του ασθενούς, συμπεριλαμβανομένων του ιστορικού, των επισκέψεων, των φαρμάκων και των επισυναπτόμενων διαγνωστικών αρχείων.",
      "Clinical Synchronization": "Κλινικός Συγχρονισμός",
      "Clinical Synchronization Desc": "Σύνδεση και συγχρονισμός πολλαπλών σταθμών εργασίας στον κεντρικό διακομιστή με ασφάλεια.",
      "Connecting a New Workstation": "Σύνδεση Νέου Σταθμού Εργασίας",
      "Connecting a New Workstation Desc": "Για να συνδέσετε έναν νέο πελάτη, εισαγάγετε το IP του κεντρικού διακομιστή στη σελίδα ρυθμίσεων. Τα δεδομένα συγχρονίζονται σε πραγματικό χρόνο.",
      "System Maintenance": "Συντήρηση Συστήματος",
      "System Maintenance Desc": "Εκτέλεση αυτοματοποιημένων αντιγράφων ασφαλείας, μεταφορά συστήματος και διαχείριση βάσης δεδομένων.",
      "Proxmox Migration": "Μεταφορά Συστήματος",
      "Proxmox Migration Desc": "Για μεταφορά συστήματος, χρησιμοποιήστε την καρτέλα 'Μεταφορά Συστήματος' στις Ρυθμίσεις. Δημιουργεί ένα αρχείο ZIP με όλα τα δεδομένα για εύκολη επαναφορά.",
      "Automated Backups": "Αυτοματοποιημένα Αντίγραφα Ασφαλείας",
      "Automated Backups Desc": "Το σύστημα διαθέτει λειτουργία δημιουργίας αντιγράφων ασφαλείας με ένα κλικ. Μεταβείτε στις Ρυθμίσεις για να κατεβάσετε ένα ασφαλές αντίγραφο της βάσης δεδομένων σας.",
      "Query & Export": "Αναζήτηση & Εξαγωγή",
      "Query & Export Desc": "Προηγμένο φιλτράρισμα ασθενών και εξαγωγή δεδομένων.",
      "Advanced Filtering": "Προηγμένο Φιλτράρισμα",
      "Advanced Filtering Desc": "Χρησιμοποιήστε τη σελίδα Αναζήτησης για να φιλτράρετε ασθενείς βάσει συγκεκριμένων κριτηρίων όπως ηλικία, ημερομηνία τελευταίας επίσκεψης και διάγνωση.",
      "Excel Export": "Εξαγωγή σε Excel",
      "Excel Export Desc": "Εξάγετε εύκολα τα αποτελέσματα της αναζήτησής σας σε ένα όμορφα διαμορφωμένο φύλλο Excel για εξωτερικό έλεγχο, αναφορές ή περαιτέρω ανάλυση.",
      "Profile": "Προφίλ",
      "Account Description": "Περιγραφή Λογαριασμού",
      "Full access — read, write, delete, manage users": "Πλήρης πρόσβαση — ανάγνωση, εγγραφή, διαγραφή, διαχείριση χρηστών",
      "Can add & edit patients, cannot delete": "Δυνατότητα προσθήκης και επεξεργασίας ασθενών, όχι διαγραφή",
      "Read-only access to all patient data": "Πρόσβαση μόνο για ανάγνωση όλων των δεδομένων ασθενών",
      "Patient Medical Record": "Κλινικός Φάκελος Ασθενούς",
      "Cards per page": "Κάρτες ανά σελίδα",
      "Delete Patient": "Διαγραφή Ασθενούς",
      "Are you sure you want to delete patient": "Είστε βέβαιοι ότι θέλετε να διαγράψετε τον ασθενή",
      "This action cannot be undone.": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
      "records": "εγγραφές",
      "patients": "ασθενείς",
      "Protocol": "Πρωτόκολλο",
      "Select PC": "Επιλογή Η/Υ",
      "Add new PC": "Προσθήκη νέου Η/Υ",
      "Delete Folder Configuration": "Διαγραφή Ρύθμισης Φακέλου",
      "This will permanently delete all patient data": "Αυτό θα διαγράψει μόνιμα όλα τα δεδομένα των ασθενών",
      "This cannot be undone": "Αυτό δεν μπορεί να αναιρεθεί",
      "To confirm, please type DELETE ALL PATIENTS below": "Για επιβεβαίωση, πληκτρολογήστε ΔΙΑΓΡΑΦΗ ΟΛΩΝ ΤΩΝ ΑΣΘΕΝΩΝ παρακάτω",
      "To proceed, please type RESTORE SYSTEM below": "Για να συνεχίσετε, πληκτρολογήστε ΕΠΑΝΑΦΟΡΑ ΣΥΣΤΗΜΑΤΟΣ παρακάτω",
      "View patients & records": "Προβολή ασθενών & αρχείων",
      "Add new patients": "Προσθήκη νέων ασθενών",
      "Edit patient data": "Επεξεργασία δεδομένων ασθενών",
      "Delete patients": "Διαγραφή ασθενών",
      "Add visits / medications / operations": "Προσθήκη επισκέψεων / φαρμάκων / επεμβάσεων",
      "Delete visits / medications / operations": "Διαγραφή επισκέψεων / φαρμάκων / επεμβάσεων",
      "Access Settings & User Management": "Πρόσβαση στις Ρυθμίσεις & Διαχείριση Χρηστών",
      "Create / delete users": "Δημιουργία / διαγραφή χρηστών",
      "Final Confirmation": "Τελική Επιβεβαίωση",
      "Only administrators can delete patients": "Μόνο οι διαχειριστές μπορούν να διαγράφουν ασθενείς",
      "Server Connection Settings": "Ρυθμίσεις Σύνδεσης Διακομιστή",
      "Configure the primary surgical hub location. These settings are stored locally on this device and are used to reach the clinical database server on your network.": "Διαμορφώστε την τοποθεσία του κύριου κλινικού διακομιστή. Αυτές οι ρυθμίσεις αποθηκεύονται τοπικά σε αυτήν τη συσκευή.",
      "Server IP or Hostname": "IP Διακομιστή ή Hostname",
      "Port": "Θύρα",
      "Test Connection": "Έλεγχος Σύνδεσης",
      "Reset to Default": "Επαναφορά Προεπιλογών",
      "Save & Apply": "Αποθήκευση & Εφαρμογή",
      "Patient Data Folders": "Φάκελοι Δεδομένων Ασθενών",
      "Configure the base directories for different PCs where patient files are stored.": "Διαμορφώστε τους καταλόγους βάσης για διαφορετικούς Η/Υ όπου αποθηκεύονται τα αρχεία των ασθενών.",
      "HTTP (Standard)": "HTTP (Τυπικό)",
      "HTTPS (Secure)": "HTTPS (Ασφαλές)",
      "Connection Username": "Όνομα Χρήστη Σύνδεσης",
      "Connection Password": "Κωδικός Σύνδεσης",
      "CONNECTION CREDENTIALS (OPTIONAL)": "ΔΙΑΠΙΣΤΕΥΤΗΡΙΑ ΣΥΝΔΕΣΗΣ (ΠΡΟΑΙΡΕΤΙΚΑ)",
      "The IP address of the machine running the Hub": "Η διεύθυνση IP του μηχανήματος που τρέχει το Hub",
      "Only if required by proxy/gateway": "Μόνο εάν απαιτείται από proxy/gateway",
      "Only if required": "Μόνο εάν απαιτείται",
      "Clinical Environment": "Κλινικό Περιβάλλον",
      "Standalone App (macOS)": "Αυτόνομη Εφαρμογή (macOS)",
      "Current Active Endpoint": "Τρέχον Ενεργό Σημείο Σύνδεσης",
      "Server path": "Διαδρομή Διακομιστή",
      "Local path": "Τοπική Διαδρομή",
      "Select Server PC": "Επιλογή Η/Υ Διακομιστή",
      "Select Local PC": "Επιλογή Τοπικού Η/Υ",
      "Create New User": "Δημιουργία Νέου Χρήστη",
      "Create User": "Δημιουργία Χρήστη",
      "Edit User": "Επεξεργασία Χρήστη",
      "Lock Account": "Κλείδωμα Λογαριασμού",
      "Unlock Account": "Ξεκλείδωμα Λογαριασμού",
      "Delete user permanently": "Μόνιμη διαγραφή χρήστη",
      "Batch Diagnosis Lookup": "Μαζική Αναζήτηση Διάγνωσης",
      "Batch Diagnosis Lookup & Export": "Μαζική Αναζήτηση & Εξαγωγή Διαγνώσεων",
      "Batch Diagnosis Lookup (Import XLSX/CSV)": "Μαζική Αναζήτηση Διάγνωσης (Εισαγωγή XLSX/CSV)",
      "Upload an Excel or CSV list of names to automatically find their clinical diagnoses and export.": "Μεταφορτώστε μια λίστα ονομάτων από Excel ή CSV για αυτόματη εύρεση των κλινικών τους διαγνώσεων και εξαγωγή.",
      "1. Import & Map Columns": "1. Εισαγωγή & Αντιστοίχιση Στηλών",
      "2. Match Diagnoses & Export": "2. Εύρεση Διαγνώσεων & Εξαγωγή",
      "Drag & drop your patient list here": "Σύρετε και αποθέστε τη λίστα ασθενών εδώ",
      "Supports Excel (.xlsx, .xls) and CSV (.csv) files": "Υποστηρίζει αρχεία Excel (.xlsx, .xls) και CSV (.csv)",
      "Browse File": "Αναζήτηση Αρχείου",
      "Change File": "Αλλαγή Αρχείου",
      "Remove File": "Αφαίρεση Αρχείου",
      "Column Mapping & Configuration": "Αντιστοίχιση Στηλών & Ρυθμίσεις",
      "Select which columns contain patient names to match against clinical records.": "Επιλέξτε ποιες στήλες περιέχουν τα ονόματα των ασθενών προς αναζήτηση στα κλινικά δεδομένα.",
      "Single Full Name Column": "Μία Στήλη Ονοματεπωνύμου",
      "Separate Last & First Names": "Ξεχωριστό Επώνυμο & Όνομα",
      "Patient Full Name Column": "Στήλη Ονοματεπωνύμου Ασθενή",
      "Last Name (Επώνυμο)": "Επώνυμο (Last Name)",
      "First Name (Όνομα)": "Όνομα (First Name)",
      "AMKA (Optional)": "ΑΜΚΑ (Προαιρετικό)",
      "Phone (Optional)": "Τηλέφωνο (Προαιρετικό)",
      "DOB (Optional)": "Ημ. Γέννησης (Προαιρετικό)",
      "None / Not in file": "Κανένα / Δεν υπάρχει στο αρχείο",
      "Previewing first {{count}} rows of {{total}} loaded records": "Προεπισκόπηση πρώτων {{count}} γραμμών από {{total}} εγγραφές",
      "Records": "Εγγραφές",
      "Searching & Matching Diagnoses...": "Αναζήτηση & Εύρεση Διαγνώσεων...",
      "Find Diagnoses for {{count}} Patients": "Εύρεση Διαγνώσεων για {{count}} Ασθενείς",
      "New File Lookup": "Νέα Αναζήτηση Αρχείου",
      "Adjust Mapping": "Προσαρμογή Αντιστοίχισης",
      "Exact Match": "Ακριβής Ταυτοποίηση",
      "Multiple Matches": "Πολλαπλές Ταυτοποιήσεις",
      "Multiple Candidates": "Πολλαπλοί Υποψήφιοι",
      "Approximate": "Κατά Προσέγγιση",
      "Not Found": "Δεν Βρέθηκε",
      "Found": "Βρέθηκαν",
      "Total Records": "Συνολικές Εγγραφές",
      "Exact Matches": "Ακριβείς Ταυτοποιήσεις",
      "Imported Search Name": "Εισαχθέν Όνομα Αναζήτησης",
      "Matched Patient": "Ταυτοποιημένος Ασθενής",
      "Primary Diagnosis": "Κύρια Διάγνωση",
      "Latest Visit Diagnosis": "Διάγνωση Τελευταίας Επίσκεψης",
      "No diagnosis recorded": "Δεν έχει καταγραφεί διάγνωση",
      "Change Match ({{count}} found)": "Αλλαγή Ταυτοποίησης ({{count}} βρέθηκαν)",
      "Select Matching Patient": "Επιλογή Ταυτοποιημένου Ασθενή",
      "Multiple patient records match \"{{name}}\". Choose the correct patient below:": "Πολλαπλοί ασθενείς ταιριάζουν με το \"{{name}}\". Επιλέξτε τον σωστό ασθενή παρακάτω:",
      "Export to Excel (.xlsx)": "Εξαγωγή σε Excel (.xlsx)",
      "Export to CSV": "Εξαγωγή σε CSV",
      "Quick Export: Excel (.xlsx)": "Γρήγορη Εξαγωγή: Excel (.xlsx)",
      "Quick Export: CSV (.csv)": "Γρήγορη Εξαγωγή: CSV (.csv)",
      "Customized Export Options...": "Προσαρμοσμένες Επιλογές Εξαγωγής...",
      "Export Diagnosis Lookup Results": "Εξαγωγή Αποτελεσμάτων Αναζήτησης Διάγνωσης",
      "Choose how you would like the exported file to be structured:": "Επιλέξτε πώς επιθυμείτε να δομηθεί το εξαγόμενο αρχείο:",
      "Preserve Original Columns + Append Diagnoses (Recommended)": "Διατήρηση Αρχικών Στηλών + Προσθήκη Διαγνώσεων (Συνιστάται)",
      "Keeps all columns from your imported Excel/CSV file and appends EMR_Primary_Diagnosis, EMR_Matched_Name, EMR_AMKA, and EMR_Match_Status.": "Διατηρεί όλες τις στήλες από το αρχείο Excel/CSV και προσθέτει EMR_Primary_Diagnosis, EMR_Matched_Name, EMR_AMKA, και EMR_Match_Status.",
      "Standardized Clinical Summary Report": "Τυποποιημένη Κλινική Αναφορά",
      "Generates a clean report containing Row #, Search Name, Matched Patient, Diagnosis, Latest Visit Diagnosis, AMKA, Age, and Phone.": "Δημιουργεί μια καθαρή αναφορά με Α/Α, Όνομα Αναζήτησης, Ταυτοποιημένο Ασθενή, Διάγνωση, Διάγνωση Επίσκεψης, ΑΜΚΑ, Ηλικία, και Τηλέφωνο.",
      "Clinical Query & Filters": "Κλινική Αναζήτηση & Φίλτρα",
      "Patient Query & Lookup": "Αναζήτηση Ασθενών & Διαγνώσεων",
      "About System": "Σχετικά με το Σύστημα",
      "Application Version": "Έκδοση Εφαρμογής",
      "MySurgeon Clinical EMR Suite": "MySurgeon Clinical EMR Suite",
      "Clinical Suite": "Κλινική Σουίτα"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
